<div class="circle-success">
    <div class="circle-ok"><i class="material-icons done-icon">done</i></div>
</div>